
import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';

const FareAlertModal = ({ alerts }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fareAlert, setFareAlert] = useState(null);

    useEffect(() => {
        const alert = alerts?.find(alert => alert.type === 'FAREALERT');
        if (alert) {
            setFareAlert(alert);
            setIsModalVisible(true);
        }
    }, [alerts]);

    const handleOk = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        let timer;
        if (isModalVisible) {
            timer = setTimeout(() => {
                handleOk();
            }, 30000);
        }

        return () => clearTimeout(timer);
    }, [isModalVisible]);

    return (
        <Modal
            title={null}
            open={isModalVisible}
            centered
            onCancel={handleOk}
            width={380}

        >
            {fareAlert && (
                <div className="fare-alert-card">
                    <h3 className='my-3'>⚠️ Fare Changed</h3>
                    <p>The price for this flight has recently changed.</p>
                    <div className="fare-info">
                        <span className="old">₹{Math.round(fareAlert.oldFare)}</span>
                        <span className="arrow">→</span>
                        <span className="new">₹{Math.round(fareAlert.newFare)}</span>
                    </div>
                    <button onClick={handleOk} className="close-btn">OK</button>
                </div>
            )}
        </Modal>
    );
};

export default FareAlertModal;

